// extracted by mini-css-extract-plugin
module.exports = {"project-card":"ProjectCard_project-card__KiZlS","text":"ProjectCard_text__2oJh_"};